import React, { useEffect, useState } from 'react';

import { Button } from 'primereact/button';
import { TreeNode } from 'types/interfaces/TreeNode';

import { GlobalSettings } from 'components/services/GlobalSettingsService';
import { TaskService } from 'components/services/TaskService';

import { useDepartmentContext } from './DepartmentContext';
import { DepartmentDropdownWithContext } from './DepartmentDropdownWithContext';

export const DepartmentCell: React.FC<{ task: any, globalSettings: GlobalSettings }> = ({ task, globalSettings }) => {
  const taskId = task.id;
  const ctx = useDepartmentContext();
  

  const initialDepartment = (() => {
    const globalSelected = ctx.selectedDepartments[taskId];
    if (globalSelected && globalSelected.key && globalSelected.key !== '') {
      return globalSelected;
    }
    if (task.department && task.department.key && task.department.key !== '') {
      return task.department;
    }
    return null; 
  })();

  const [selectedDepartment, setSelectedDepartment] = useState<TreeNode | null>(initialDepartment);
  
  const hasAssetOrTaskType = !!(task.assetId || task.taskTypeId);
  const isSelected = !!(selectedDepartment && selectedDepartment.key && selectedDepartment.key !== '');

  useEffect(() => {
    const globalSelected = ctx.selectedDepartments[taskId];
    if (globalSelected && globalSelected.key && globalSelected.key !== '') {
      setSelectedDepartment(globalSelected);
    } else if (!globalSelected) {
      setSelectedDepartment(null);
    }
  }, [ctx.selectedDepartments[taskId], taskId]);

  const handleSelect = (id: number, department: TreeNode | null) => {
    const validDepartment = department && department.key && department.key !== '' ? department : null;
    setSelectedDepartment(validDepartment);
    ctx.setSelectedDepartments(prev => ({ ...prev, [id]: validDepartment }));
  };

  const handleAssign = async () => {
    if (!selectedDepartment || !selectedDepartment.key) return;
    const response = await TaskService.updateTaskDepartmentAssignment(
      taskId,
      selectedDepartment.key
    );
    if (response.data.isSuccess) {
      await ctx.loadTasks();
      ctx.setSelectedDepartments(prev => {
        const newState = { ...prev };
        delete newState[taskId];
        return newState;
      });
      setSelectedDepartment(null);
    }
  };
  
  return (
    <div className="flex align-items-center gap-2" style={{ width: 430 }}>
      <div className="col">
        <DepartmentDropdownWithContext
          taskId={taskId}
          currentDepartment={selectedDepartment}
          hasAssetOrTaskType={hasAssetOrTaskType}
          assetId={task.assetId}
          taskTypeId={task.taskTypeId}
          plannedStartDate={task.plannedStartDate}
          plannedEndDate={task.plannedEndDate}
          onSelect={handleSelect}
          globalSettings={globalSettings}
        />
      </div>
      <Button
        type="button"
        label="Назначить"
        icon="pi pi-check"
        onClick={handleAssign}
        disabled={!isSelected}
        severity={isSelected ? 'success' : 'secondary'}
        style={{ minWidth: 135 }}
      />
    </div>
  );
};
